import { SidebarItem, SidebarSubmenu } from '@backstage/core-components';
import { IconComponent } from '@backstage/core-plugin-api';
import { AllTeams } from './AllTeams';
import { TeamSubMenu } from './TeamSubMenu';
import { enablingAndPlatformTeams } from './enablingAndPlatformTeams';
import { useMyTeams } from './useMyTeams';

export interface TeamsSidebarItemProps {
  icon: IconComponent;
}

export const TeamsSidebarItem = (props: TeamsSidebarItemProps) => {
  const { icon } = props;
  const myTeams = useMyTeams();

  return (
    <SidebarItem icon={icon} text="Teams" to="groups">
      <SidebarSubmenu>
        <AllTeams icon={icon} />
        <TeamSubMenu icon={icon} teams={myTeams} title="My Teams" />
        <TeamSubMenu
          icon={icon}
          teams={enablingAndPlatformTeams}
          title="Enabling & Platform Teams"
        />
      </SidebarSubmenu>
    </SidebarItem>
  );
};
